import React, { Component, Fragment } from "react";
import Calendar from "../common/Calendar";
import HotModIndicator from "../common/HotModIndicator";

class POTable extends Component {
  state = { openCalendar: true };
  constructor(props) {
    super(props);
    this.tableHeader = this.props.tableHeader;
    this.tableRef = React.createRef();
    this.tableHeaderRef = React.createRef();
    this.initialData = [];
    this.statuses = { O: "O-OPEN", R: "R-RECV", C: "C-CANC", H: "H-HOLD" };
  }

  renderTableHeader = () => {
    return this.tableHeader.map(title => {
      return (
        <div key={title} className="table-cell">
          <h4 className="table-title table-text">{title}</h4>
        </div>
      );
    });
  };

  numberToZeroPadded = (num, z) => {
    var zeros = z - (num + "").length;
    for (let i = 0; i < zeros; i++) {
      num = "0" + num;
    }
    return num;
  };
  renderTableRows = () => {
    if (this.props.data) {
      return this.props.data.map((row, i) => {
        this["rowRef" + i] = React.createRef();
        this["shipDateRef" + i] = React.createRef();
        this["arrvialDateRef" + i] = React.createRef();

        return (
          <div key={i} className={"table-row-wrapper"}>
            <input
              id={`rowRad${i}`}
              className="rowInput"
              name="rowRad"
              type="radio"
            />
            <label
              htmlFor={`rowRad${i}`}
              ref={this["rowRef" + i]}
              onClick={e =>
                this.props.getRowInfo(this["rowRef" + i].current, row)
              }
              className={`table-row ${row.status === "C" ? "canceled" : ""}`}
            >
              <div
                className="table-cell selectable"
                onClick={e =>
                  this.props.redirect({
                    purchaseOrder: row,
                    sufixes: this.props.data
                  })
                }
              >
                <p className="table-text">
                  <i className="material-icons">search</i>
                </p>
              </div>
              <div className="table-cell">
                <p className="table-text">
                  {this.numberToZeroPadded(row.suffix, 2)}
                </p>
              </div>
              <div className="table-cell select with-hotmod">
                {row.status === "O" || row.status === "C" ? (
                  <select
                  // onChange={e =>
                  //   this.props.getRowInfo(this["rowRef" + i].current, row)
                  // }
                  // className="table-text"
                  >
                    {row.status === "C" ? (
                      <Fragment>
                        <option value="C">{this.statuses["C"]}</option>
                        <option value="O">{this.statuses["O"]}</option>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <option value="O">{this.statuses["O"]}</option>
                        <option value="C">{this.statuses["C"]}</option>
                      </Fragment>
                    )}
                  </select>
                ) : (
                  <select
                    style={{
                      MozAppearance: "window",
                      WebkitAppearance: "none",
                      cursor: "default",
                      marginRight: 0,
                      fontSize: "95%"
                    }}
                    disabled
                  >
                    <option value={row.status}>
                      {this.statuses[row.status]}
                    </option>
                  </select>
                )}
                <div
                  className={`hotmod ${
                    this.props.changes[
                      this.props.poh_number.poNumber + "-" + row.suffix
                    ] &&
                    this.props.changes[
                      this.props.poh_number.poNumber + "-" + row.suffix
                    ].status !== row.status
                      ? "on"
                      : "off"
                  }`}
                >
                  <HotModIndicator />
                </div>
              </div>

              <div
                id="shipped-date"
                className="table-cell calendar-input with-hotmod"
                ref={this["shipDateRef" + i]}
                onMouseEnter={e =>
                  this.validateCalendar(this["rowRef" + i], "shipped")
                }
                onClick={
                  this.state.openCalendar
                    ? e => this.onClickCalendar(this["shipDateRef" + i].current)
                    : e => this.props.sendErrorMessage(this.state.error)
                }
              >
                <p className="table-text">{row.shipDate}</p>
                <i className="material-icons">date_range</i>
                <div
                  className={`hotmod ${
                    this.props.changes[
                      this.props.poh_number.poNumber + "-" + row.suffix
                    ] &&
                    this.props.changes[
                      this.props.poh_number.poNumber + "-" + row.suffix
                    ].shipDate !== row.shipDate
                      ? "on"
                      : "off"
                  }`}
                >
                  <HotModIndicator />
                </div>
              </div>
              <div
                id="arrival-date"
                className="table-cell calendar-input with-hotmod"
                ref={this["arrvialDateRef" + i]}
                onMouseEnter={e =>
                  this.validateCalendar(this["rowRef" + i], "arrival")
                }
                onClick={
                  this.state.openCalendar
                    ? e =>
                        this.onClickCalendar(this["arrvialDateRef" + i].current)
                    : e => this.props.sendErrorMessage(this.state.error)
                }
              >
                <p className="table-text">{row.arrivalDate}</p>
                <i className="material-icons">date_range</i>
                <div
                  className={`hotmod ${
                    this.props.changes[
                      this.props.poh_number.poNumber + "-" + row.suffix
                    ] &&
                    this.props.changes[
                      this.props.poh_number.poNumber + "-" + row.suffix
                    ].arrivalDate !== row.arrivalDate
                      ? "on"
                      : "off"
                  }`}
                >
                  <HotModIndicator />
                </div>
              </div>
              <div className="table-cell">
                <p className="table-text">{row.totalItems}</p>
              </div>
              <div className="table-cell">
                <p className="table-text">
                  {this.numberWithCommas(row.totalWeight, 0)}
                </p>
              </div>
              <div className="table-cell">
                <p className="table-text">
                  {this.numberWithCommas(row.totalUnits, 0)}
                </p>
              </div>
              <div className="table-cell">
                <div
                  className="table-cell-div-wrapper"
                  style={{
                    padding: "0 20px"
                  }}
                >
                  <p style={{ width: "fit-content" }} className="table-text">
                    $
                  </p>
                  <p style={{ width: "fit-content" }} className="table-text">
                    {this.numberWithCommas(row.totalCost, 2)}
                  </p>
                </div>
              </div>
            </label>
          </div>
        );
      });
    }
  };
  onClickCalendar = ref => {
    this.props.onClick(
      "success",
      "Input...",
      <Calendar getDate={this.props.getDate} calendarRef={ref} />,
      "format_list_bulleted",
      "Close"
    );
    this.props.sendErrorMessage("");
  };
  validateCalendar(ref, input) {
    if (
      (input === "shipped" &&
        // eslint-disable-next-line
        ref.current.children[1].firstChild.textContent == 0 &&
        ref.current.children[2].firstChild.value === "O") ||
      ((input === "arrival" &&
        ref.current.children[2].firstChild.value === "O") ||
        ref.current.children[2].firstChild.value === "H")
    ) {
      this.setState({ openCalendar: true });
    } else {
      this.setState({ openCalendar: false });
      input === "shipped"
        ? this.setState({
            error:
              "Shipped date can only be updated if status = Open and suffix = 0."
          })
        : this.setState({
            error: "Arrival date can only be updated if status = Hold or Open."
          });
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = event => {
    if (this.tableRef.current.getBoundingClientRect().top > 0) {
      // eslint-disable-next-line
      this.state.isHeaderFixed !== false
        ? (this.tableHeaderRef.current.classList = "table-row title-row")
        : null;
    } else {
      // eslint-disable-next-line
      this.state.isHeaderFixed !== true
        ? (this.tableHeaderRef.current.classList =
            "table-row title-row fixed-to-top")
        : null;
    }
  };
  numberWithCommas = (number, decimals) => {
    var parts = number
      .toFixed(decimals)
      .toString()
      .split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };
 
  render() {
    return (
      <div ref={this.tableRef} className="table-container">
        <div ref={this.tableHeaderRef} className="table-row title-row">
          {this.renderTableHeader()}
        </div>
        {this.renderTableRows()}
      </div>
    );
  }
}

export default POTable;
